import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { GroupsPage } from '@/features/groups/components';

function GroupsRoute(): ReactNode {
  return <GroupsPage />;
}

export const Route = createFileRoute('/groups/')({
  component: GroupsRoute,
});
